export default class Animation {
  /**
   * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
   * force an animation
   */
  static slideUp(element) {
    element.style.height = element.scrollHeight + 'px'; // Force previous height to allow CSS transition
    element.offsetHeight; // Force redraw
    element.style.height = 0;
  }

  /**
   * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
   * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
   */

  static slideDown(element) {
    if (element.style.height === 'auto') {
      return;
    }

    // To do the animation we temporarily hide it, check the height, and transition to it
    element.style.height = element.firstElementChild.scrollHeight + 'px';

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === 'height') {
        element.style.height = 'auto'; // Allows the content to grow normally
        element.removeEventListener('transitionend', transitionEnded);
      }
    };

    element.addEventListener('transitionend', transitionEnded);
  }
}